// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"S4-z"};